import {Component, OnInit} from '@angular/core';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationHelperService} from '../../../services/helpers/authentication-helper.service';

@Component({
  selector: 'tl-social-page',
  templateUrl: './social-page.component.html',
})
export class SocialPageComponent implements OnInit {
  isSpinnerActive = false;
  google = false;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    protected authHelperService: AuthenticationHelperService) {
  }

  ngOnInit(): void {
    if (this.activatedRoute.snapshot.url.map(segment => segment.path).join('/') === PAGES_AND_PATHS.googleSignUp.pageInRouting) {
      this.google = true;
    }
  }

  confirmSocial(): void {
    this.router.navigate([PAGES_AND_PATHS.completeRegistrationSocial.pagePath]);
  }
}
